import { Injectable } from '@angular/core';

@Injectable()
export class Constants {
  public static readonly emailRegExp = /^[\w ]+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.[\w ]{2,})+$/;
  public static readonly urlRegExp = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
}
